import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { MotionConfig } from "framer-motion";
import { useEffect } from "react";
import { Toaster, toast } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AIConcierge from "./components/AIConcierge";
import BookingModal from "./components/BookingModal";
import Home from "./pages/Home";
import Rooms from "./pages/Rooms";
import Corporate from "./pages/Corporate";
import Dining from "./pages/Dining";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Visit from "./pages/Visit";
import Admin from "./pages/Admin";
import "./index.css";

function ScrollTop() {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    // Instant top on route change — no smooth easing so back/forward feels snappy.
    if (lenis) lenis.scrollTo(0, { immediate: true, force: true });
    else window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, lenis]);
  return null;
}

function AdminSignedOutToast() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (pathname === "/" && search.includes("admin_signed_out=1")) {
      toast.success("You have been securely signed out of the admin panel.");
      window.history.replaceState({}, "", "/");
    }
  }, [pathname, search]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/secure-admin");
  return (
    <>
      <ScrollTop />
      <AdminSignedOutToast />
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/rooms" element={<Rooms />} />
        <Route path="/corporate" element={<Corporate />} />
        <Route path="/dining" element={<Dining />} />
        <Route path="/visit-holbrook" element={<Visit />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/secure-admin" element={<Admin />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <AIConcierge />}
      <BookingModal />
    </>
  );
}

export default function App() {
  return (
    <ReactLenis root options={{ lerp: 0.11, smoothWheel: true, syncTouch: false, wheelMultiplier: 1.0 }}>
      <MotionConfig reducedMotion="never">
        <BrowserRouter>
          <Shell />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </MotionConfig>
      <style>{`@keyframes bounce{0%,100%{transform:translateY(0)}50%{transform:translateY(-4px)}}`}</style>
    </ReactLenis>
  );
}
